<template>
  <div class="font-14 color-555 get-start-wrap">
    <div class="get-start-top-wrap">
      <div>
        <img :src="appDemoBg" alt />
      </div>
      <div>
        <div class="get-start-title">{{ $t('landing.getStarted.title') }}</div>
        <div class="get-start-view-all">
          <span></span>
        </div>

        <ul class="get-start-list">
          <li v-for="(item, index) in list" :key="index">
            <div class="get-start-list-icon">
              <img :src="item.icon" alt />
            </div>
            <div>
              <div class="get-start-list-title">{{ item.title }}</div>
              <div class="get-start-list-desc">{{ item.desc }}</div>
            </div>
          </li>
        </ul>
        <div id="appLinks" class="get-start-btn">
          <a v-for="(value, name, index) in btnList" :href="value.path" target="_blank" :key="index">
            <img :src="value.icon" alt />
          </a>
        </div>
      </div>
    </div>

    <div class="get-start-btm-wrap">
      <div class="font-16 text-bold get-start-desc">
        <p>{{ $t('landing.getStarted.desc') }}</p>
      </div>
    </div>

    <div class="get-start-partner-title-wrap">
      <div class="text-bold get-start-partner-title">
        <p>{{ $t('landing.partner.title') }}</p>
      </div>
    </div>

    <div class="get-start-partner-wrap">
      <div class="get-start-wallet">
        <div class="get-start-partner-img">
          <img :src="walletBg" alt />
        </div>

        <div class="get-start-partner-desc">
          <p>
            {{ $t('landing.partner.wallet.text') }}
            <a href="https://www.maxonrow.com/max-wallet/" target="_blank" class="max-link">{{
              $t('landing.partner.wallet.link')
            }}</a>
          </p>
        </div>
      </div>

      <div class="get-start-cipher">
        <div class="get-start-partner-img">
          <img :src="cipherBg" alt />
        </div>

        <div class="get-start-partner-desc">
          <p>{{ $t('landing.partner.cipher.text') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Banner',
  components: {},
  data() {
    return {
      appDemoBg: require('@/assets/images/home/app_demo.png'),
      walletBg: require('@/assets/images/home/max-wallet.png'),
      tickImg: require('@/assets/images/tick.svg'),
      cipherBg: require('@/assets/images/home/cipher-trace.png'),
      btnList: {
        // grx_ios_store: { icon: require('@/assets/images/home/grx_ios_store.svg'), path: '' },
        grx_android_store: { icon: require('@/assets/images/home/grx_android_store.svg'), path: '' },
        // grx_ipa: { icon: require('@/assets/images/home/grx_ios_ipa.svg'), path: '' },
        grx_apk: { icon: require('@/assets/images/home/grx_android_apk.svg'), path: '' }
      },
      currentCoin: 'GRX',
      list: [
        {
          icon: require('@/assets/images/home/get_start_1.png'),
          title: this.$t('landing.getStarted.sec.1'),
          desc: this.$t('landing.getStarted.desc.1')
        },
        {
          icon: require('@/assets/images/home/get_start_2.png'),
          title: this.$t('landing.getStarted.sec.2'),
          desc: this.$t('landing.getStarted.desc.2')
        },
        {
          icon: require('@/assets/images/home/get_start_3.png'),
          title: this.$t('landing.getStarted.sec.3'),
          desc: this.$t('landing.getStarted.desc.3')
        }
      ]
    };
  },
  created() {
    this.assignEnvConfig();
  },
  methods: {
    assignEnvConfig() {
      //this.btnList['grx_ios_store'].path = 'https://apps.apple.com/us/app/grxtrade/id1495956494?ls=1';
      this.btnList['grx_android_store'].path = 'https://play.google.com/store/apps/details?id=com.grxtrade.app';
      //this.btnList['grx_ipa'].path = window.env.grxApp.ipa;
      this.btnList['grx_apk'].path = window.env.grxApp.apk;
    }
  }
};
</script>

<style scoped>
.get-start-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 25px 50px;
}
.get-start-top-wrap {
  display: flex;
  justify-content: center;
  padding: 84px 15px 0;
}
.get-start-top-wrap > div {
  /* flex: 1 1 0px; */
  max-width: 800px;
}
.get-start-title {
  font-size: 30px;
  color: rgba(85, 85, 85, 1);
  padding: 0 15px 13px;
}
.get-start-view-all {
  font-size: 14px;
  color: rgba(85, 85, 85, 1);
  padding-bottom: 15px;
}
.get-start-list {
  display: flex;
  flex-direction: column;
}
.get-start-list > li {
  display: flex;
  align-items: center;
  padding: 15px 0;
}
.get-start-list-icon {
  flex: 0 0 64px;
}
.get-start-list-title {
  font-size: 16px;
  font-weight: bold;
  color: rgba(85, 85, 85, 1);
}
.get-start-list-desc {
  font-size: 14px;
  color: rgba(170, 170, 170, 1);
}
.get-start-btn {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 30px;
}
.get-start-btn a {
  cursor: pointer;
  width: 140px;
  height: 45px;
  opacity: 1;
  border-radius: 4px;
  margin: 20px;
}
.get-start-btn a img {
  width: 100%;
}
.get-start-btn a:active {
  opacity: 0.9;
}
.get-start-btm-wrap {
  padding: 0 15%;
}
.get-start-desc {
  text-align: center;
}

.get-start-partner-title {
  padding: 100px 15px 0px;
  font-size: 30px;
}

.get-start-partner-wrap {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: center;
  text-align: center;
}

.get-start-partner-wrap > div {
  flex-basis: 400px;
  padding: 50px 15px 0;
}

.get-start-wallet,
.get-start-cipher {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.get-start-partner-img {
  padding-bottom: 20px;
  height: 130px;
  display: flex;
  align-items: center;
}

.get-start-partner-img > img {
  max-width: 130px;
  max-height: 130px;
}

.get-start-partner-desc {
  padding-top: 20px;
}

.max-link {
  color: blue;
  text-decoration: underline;
}

.max-link:visited {
  color: rgba(17, 21, 34, 0.9);
}

@media screen and (max-width: 1200px) {
  .get-start-top-wrap {
    flex-direction: column;
    align-items: center;
  }

  .get-start-top-wrap > div:nth-child(1) {
    max-width: 300px;
  }

  .get-start-title {
    text-align: center;
  }

  .get-start-btn {
    justify-content: center;
  }

  .get-start-list {
    padding: 0 50px;
  }
}

@media screen and (max-width: 576px) {
  .get-start-list > li {
    align-items: flex-start;
  }

  .get-start-list-icon {
    margin-top: 10px;
  }

  .get-start-list {
    padding: 0px 25px;
  }
}
</style>
